import { Component, Input } from "@angular/core";
import { NavigationService } from "../../../../common/navigation/navigation.service";
import { TranslateService } from "app/common/translate";

@Component({
	selector: "sdp-forgot-password-email-pending",
	templateUrl: "./forgot-password-email-pending.component.html"
})
export class ForgotPasswordEmailPendingComponent {
	@Input()
	public email = "";

	constructor(
		private navigationService: NavigationService,
		private translateService: TranslateService
	) { }

	public back() {
		this.navigationService.navigate(["/login/login"]);
	}

	public get messages() {
		return [
			"forgotpassword.verify.1",
			"forgotpassword.verify.2",
			"forgotpassword.verify.3"
		]
			.map((message) => this.translateService.translate(
				message,
				{
					email: this.email
				}
			));
	}
}
